import { render, staticRenderFns } from "./mdm-form-report.vue?vue&type=template&id=23a37e5b&"
import script from "./mdm-form-report.vue?vue&type=script&lang=js&"
export * from "./mdm-form-report.vue?vue&type=script&lang=js&"
import style0 from "./mdm-form-report.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports